export const ADDCART = "cart/addCart";
export const UPDATECART = "cart/updateCart";
export const INCRMENT = "cart/increment";
export const DECREMENT = "cart/decrement";
export const DELETE = "cart/delete";
